import type { TabItem } from '../components/Tab/Tab.vue'
import { once } from 'lodash-es'

interface UseLayoutSettings {
  siteName: string
  articlePageUrl: string
  homePageUrl: string
  tabCategories: TabItem[]
  videoPageUrl: string
  siteDomain?: string
  headerLogo?: string
  headerLogoDarkMode?: string
  headerSize?: { width: number; height: number }
  tagline?: string
  footerBrandName?: string
}

export const useGlobalLayoutSettings = defineStore('app:layoutSettings', () => {
  const layoutSettings = ref<UseLayoutSettings>({
    siteName: '',
    articlePageUrl: '',
    homePageUrl: '',
    tabCategories: [],
    videoPageUrl: '',
    headerLogo: '',
    headerLogoDarkMode: '',
    tagline: '',
    footerBrandName: '',
  })

  const setup = once((settings: UseLayoutSettings) => {
    layoutSettings.value = {
      ...layoutSettings.value,
      ...settings,
    }
  })

  const settings = computed(() => {
    return layoutSettings.value
  })

  const siteSettingsStore = useSiteSettingsStore()
  const { data: siteSettings } = storeToRefs(siteSettingsStore)

  const filteredTabCategories = computed(() =>
    settings.value.tabCategories.filter(
      (tab) => tab.id !== 'Games' || siteSettings.value.gamesEnabled
    )
  )

  return {
    setup,
    settings,
    filteredTabCategories,
  }
})
